import { useAppThemeLocalStorageConnector } from './useAppThemeLocalStorageConnector';
import { useEffectSetThemeFromApi } from './useEffectSetThemeFromApi';
/**
 * Connects the theme from the user's profile to the theme data.
 */
export const useAppThemeConnector = () => {
    // Check local storage first as the API takes time to load
    useAppThemeLocalStorageConnector();
    useEffectSetThemeFromApi();
};
